import { ChangeDetectionStrategy, Component, OnInit, Input, ViewEncapsulation, OnChanges, ChangeDetectorRef } from '@angular/core';
import { Information } from '../../../models/information.model';
import { Customer, InformationGroup, MeteringPoint } from '@model';
import { InformationType, UserType } from '@enums';
import * as fromStore from '@core/store';
import * as fromAccountStore from '@appStore/account';
import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';
import { transition, trigger, useAnimation } from '@angular/animations';
import { fadeIn, fadeOut } from './carousel.animation';


@Component({
    selector: 'app-carousel-display',
    templateUrl: './carousel-display.component.html',
    animations: [
        trigger('carouselAnimation', [
            transition('void => *', [useAnimation(fadeIn, { params: { time: '1000ms' } })]),
            transition('* => void', [useAnimation(fadeOut, { params: { time: '1000ms' } })]),
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CarouselDisplayComponent implements OnInit, OnChanges {
  @Input() informationGroup: InformationGroup;
  @Input() customers: Customer[];
  @Input() userType: UserType;
  @Input() meteringPoints: MeteringPoint[];

  informationTypeEnum = InformationType;
  informationGroupView: InformationGroup;

  slides: Information[] = [];
  unreadCount = 0;
 
  private subs = new SubSink();
  isImpersonating: any;

  hidden = false;
  show = false;

  currentIndex = 0;

  constructor(private informationStore: Store<fromStore.InformationState>,
    private accountStore: Store<fromAccountStore.State>,
    private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
 
    this.hidden = this.hideContent(this.customers, this.meteringPoints, this.userType);

    this.createLocalView();

    this.subs.sink = this.accountStore.select(fromAccountStore.getUserInfo).subscribe(userInfo => {
      this.isImpersonating = !!userInfo.impersonatedAsName;
    });
  }

  hideContent(customers: Customer[], meteringPoints: MeteringPoint[], userType: UserType): boolean {

    // Show Information as disabled if no customer is registered on User (not Manager)
    // !isManger && noCustomerRegistered

    // If User is Manager and has no access to any meteringpoints on Customers or no Customers and MeteringPoints
    // !noCustomerRegistered && noAccessToMeteringPoints && isManger

    let isManger = this.userType === UserType.Manager;
    let noAccessToMeteringPoints = this.meteringPoints?.length === 0;
    let noCustomerRegistered = this.customers?.length === 0;

    if (!isManger && noCustomerRegistered) {
      return true;
    }
    if ((!noCustomerRegistered && noAccessToMeteringPoints) || (noCustomerRegistered && noAccessToMeteringPoints) && isManger) {
      return true;
    }
  }

  ngOnChanges() {
    this.createLocalView();
  }
  
  createLocalView() {
    if (this.informationGroup && this.informationGroup.informations.length > 0) {
      this.show = true;

      this.unreadCount = this.informationGroup.unReadCount;

      this.slides = this.informationGroup.informations.map(x => <Information>{
        ...x,
        // ingress: 'Se hur prisjusteringarna påverkar dig och läs om hur vi säkrar värmeleveransen i ett utmanande omvärldsläge. '
        });
       // Force the view to update
      this.changeDetectorRef.detectChanges();
    }
  }

  onPreviousClick(id: number): void {
    const isFirstSlide = this.currentIndex === 0;
    const newIndex = isFirstSlide
      ? this.slides.length - 1
      : this.currentIndex - 1;

    if (this.currentIndex !== newIndex) {
        this.setAsRead(id); // set existing as read
    }
  
    // set new current
    this.currentIndex = newIndex;
  }
  
  onNextClick(id: number): void {
    const isLastSlide = this.currentIndex === this.slides.length - 1;
    const newIndex = isLastSlide ? 0 : this.currentIndex + 1;

    if (this.currentIndex !== newIndex) {
      this.setAsRead(id); // set existing as read
    }
  
    // set new current
    this.currentIndex = newIndex;
  }

  onSlideClick(slideIndex: number, id: number): void {

    if (this.currentIndex !== slideIndex) {
      this.setAsRead(id);
    }

    // set new current
    this.currentIndex = slideIndex;
  }

  setAsRead(id: number) {
    if (id) {
      if (!this.isImpersonating) {
        this.informationStore.dispatch(new fromStore.InformationSetAsRead(id));
      }
    }
  }
}

